// --- Raids ---
export const RAIDS = "/raids" as const;
export const RAIDS_FAVORITES = "/raids/favorites" as const;
export const RAID_BY_ID = "/raids/{raidId}" as const;
export const RAID_START = "/raids/{raidId}/start" as const;
export const RAID_CLOSE = "/raids/{raidId}/close" as const;
export const RAID_MELANGE_PREVIEW = "/raids/{raidId}/melange-preview" as const;
export const RAID_AUTHORISATION = "/raids/{raidId}/authorisation" as const;
export const RAID_ADMIN_PIN = "/raids/{raidId}/admin-pin" as const;
export const RAID_TIME_TRACK_START = "/raids/{raidId}/time-track/{participantId}/start" as const;
export const RAID_TIME_TRACK_STOP = "/raids/{raidId}/time-track/{participantId}/stop" as const;

// --- Participants ---
export const PARTICIPANT_MARK_RESOURCES_RETRIEVED = "/participant/{participantId}/mark-resources-retrieved" as const;

// --- Account ---
export const ACCOUNT = "/account" as const;
